import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-collaboration-icon',
  templateUrl: './collaboration-icon.component.html',
  styles: [
    `
      .collaboration-icon-container {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        :is(span) {
          position: absolute;
          top: 0;
          right: 0;
          background-color: #333;
          color: #fff;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          font-weight: 600;
          z-index: 10;
        }
      }
    `,
  ],
})
export class CollaborationIconComponent {
  @Input() type: 'AYUDA' | 'VALIDACION' | 'DENUNCIA' = 'AYUDA';
  @Input() value: number = 0;
  @Input() link: string = '';

  kc = inject(KeycloakService);

  async openLink() {
    const isLoggedIn = await this.kc.isLoggedIn();
    if (!isLoggedIn) {
      await this.kc.login({
        redirectUri: this.link,
        idpHint: environment.keycloak_idpHint,
        locale: 'es',
      });
      return;
    }
    if (this.link) {
      window.open(this.link, '_blank');
    }
  }
}
